<template>
    <main class="a-opinion-polls a-main" id="a-opinion-polls">
        <div class="a-main__container">
            <div class="a-main__title a-opinion-polls__title">
                {{ title }}
            </div>
            <polls :pollsData="jsonAssessmentNew" />
            <div class="a-opinion-polls__wrapper">
                <evaluation :evaluation="jsonPolls" />
                <quiz />
            </div>
            <div class="a-opinion-polls__component">
                <loader v-if="researchIsLoading" />
                <error v-if="researchError" />
                <research v-if="research"
                    :desktop-small-device="desktopSmallDevice"
                    :desktop-device="desktopDevice"
                    :mobile-device="mobileDevice"
                    :tablet-device="tabletDevice"
                    :research-data-items="research"
                    :research-data="researchData"
                    @option-selected="optionSelected"
                    @date-selected="dateSelected"
                    @show-more-press="showMorePress" />
            </div>
            <overview
                :overview-data="overviewData"
                :json-overview-data="jsonHousingAndMortage" />
        </div>
    </main>
</template>

<script>
    import Loader from '../Loader'
    import Error from '../Error' 
    import Polls from './components/Polls'
    import Evaluation from './components/Evaluation'
    import Quiz from './components/Quiz'
    import Research from '../Research'
    import Overview from '../Overview'
    import headerSearchHandler from '../../modules/a-main-nav'
    import {researchActionTypes} from '../../store/modules/research'
    import {mapState} from 'vuex'

    export default {
        name: 'OpinionPolls',
        components: {
            Polls,
            Evaluation,
            Quiz,
            Research,
            Overview,
            Loader,
            Error
        },
        data() {
            return {
                title: 'Опросы',
                apiResearch: '/api/v2/content/analytics/list/',
                dateFrom: '',
                dateTo: '',
                pageParams: '',
                jsonPolls: null,
                jsonHousingAndMortage: null,
                jsonAssessment: null,
                jsonAssessmentNew: null,
                jsonPollsReport: null,
                researchData: {
                    title: 'Социологические опросы населения',
                    link: {
                        href: '/analytics/archive/?section=844',
                        title: 'Архив отчетов',
                    },
                },
                overviewData: {
                    imageData: {
                        src: '/static/v2/src/img/analytics/opinion-polls/overview',
                        alt: 'Жилье и ипотека',
                        width: '935',
                        height: '583'
                    },
                },
            }
        },
        computed: {
            ...mapState({
                researchIsLoading: state => state.research.isLoading,
                research: state => state.research.data,
                researchError: state => state.research.error,
            }),
            mobileDevice () {
                return typeof window === 'object' && window.innerWidth < 768
            },
            tabletDevice () {
                return typeof window === 'object' && window.innerWidth >= 768 && window.innerWidth < 1025
            },
            desktopSmallDevice () {
                return typeof window === 'object' && window.innerWidth >= 1025 && window.innerWidth < 1200
            },
            desktopDevice () {
                return typeof window === 'object' && window.innerWidth >= 1200
            }
        },
        methods: {
            optionSelected (id) {
                this.dateFrom = ''
                this.dateTo = ''
                this.$store.dispatch(researchActionTypes.getResearch, {apiUrl: this.apiResearch, searchValue: '?section=844&include=Y'})
            },

            dateSelected (dateStart, dateEnd) {
                this.dateFrom = dateStart
                this.dateTo = dateEnd
                this.pageParams = `?section=844&date-from=${this.dateFrom}&date-to=${this.dateTo}&include=Y`
                this.$store.dispatch(researchActionTypes.getResearch, {apiUrl: this.apiResearch, searchValue: this.pageParams})
            },

            showMorePress (pageCounter) {
                if (this.dateFrom) {
                    this.pageParams = `?section=844&date-from=${this.dateFrom}&date-to=${this.dateTo}&page=${pageCounter}&include=Y`
                } else {
                    this.pageParams = `?section=844&page=${pageCounter}&include=Y`
                }

                this.$store.dispatch(researchActionTypes.getMoreData, {apiUrl: this.apiResearch, searchValue: this.pageParams})
            }
        },
        mounted() {
            this.$store.dispatch(researchActionTypes.getResearch, {apiUrl: this.apiResearch, searchValue: '?section=844&include=Y'})
            headerSearchHandler()
        },
        beforeMount() {
            const page = document.querySelector('#app')
            this.jsonPolls = JSON.parse(page.getAttribute('last-polls'))
            this.jsonHousingAndMortage = JSON.parse(page.getAttribute('housing-and-mortage'))
            this.jsonAssessment = JSON.parse(page.getAttribute('assessment-of-business-activity'))
            this.jsonPollsReport = JSON.parse(page.getAttribute('polls-report'))
            const colors = [
              {
                color: '#67A511',
                text: 'перевыполнен'
              },
              {
                color: '#A3D562',
                text: 'выполнен'
              },
              {
                color: '#9AC2FF',
                text: 'не выполнен'
              }
            ]
            this.jsonAssessmentNew = {
              title: this.jsonAssessment.title,
              desc: this.jsonAssessment.data[0].title,
              charts: this.jsonAssessment.data[0].values,
              items: this.jsonAssessment.data[1].values,
              colors: colors.map((item,index) => {
                item.text = this.jsonAssessment.data[0].legend[index]
                return item
              }),
              conclusion: this.jsonAssessment.data[1].title
            }
        }

    }
</script>